
;(function seibertronSps4PlusGalleryRestore20260713() {
  var handle = 'seibertron-sps-4-plus-3m-thinsulate-motorcycle-gloves';
  var chartFile = 'sps4plus-adult-youth-size-chart-user-20260724-v2.jpg';
  var entries = [
    {
        "id": "33435717009598",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-black-white-bg-main-20260713.jpg?v=1783958430",
        "alt": "color:Black | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374600986814",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-01.jpg?v=1783398175",
        "alt": "color:Black | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 01"
    },
    {
        "id": "33374601019582",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-02.jpg?v=1783398176",
        "alt": "color:Black | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 02"
    },
    {
        "id": "33374601052350",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-03.jpg?v=1783398175",
        "alt": "color:Black | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 03"
    },
    {
        "id": "33374601085118",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-04.jpg?v=1783398175",
        "alt": "color:Black | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 04"
    },
    {
        "id": "33435717435582",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-white-white-bg-main-20260713.jpg?v=1783958438",
        "alt": "color:White | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374601117886",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-05.jpg?v=1783398175",
        "alt": "color:White | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 05"
    },
    {
        "id": "33374601150654",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-06.jpg?v=1783398175",
        "alt": "color:White | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 06"
    },
    {
        "id": "33374601183422",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-07.jpg?v=1783398175",
        "alt": "color:White | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 07"
    },
    {
        "id": "33374601216190",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-08.jpg?v=1783398176",
        "alt": "color:White | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 08"
    },
    {
        "id": "33435717599422",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-brown-white-bg-main-20260713.jpg?v=1783958445",
        "alt": "color:Brown | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374601248958",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-09.jpg?v=1783398175",
        "alt": "color:Brown | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 09"
    },
    {
        "id": "33374601281726",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-10.jpg?v=1783398176",
        "alt": "color:Brown | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 10"
    },
    {
        "id": "33374601314494",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-11.jpg?v=1783398176",
        "alt": "color:Brown | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 11"
    },
    {
        "id": "33374601347262",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-12.jpg?v=1783398175",
        "alt": "color:Brown | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 12"
    },
    {
        "id": "33435718811838",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-gray-white-bg-main-20260713.jpg?v=1783958452",
        "alt": "color:Gray | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374601380030",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-13.jpg?v=1783398175",
        "alt": "color:Gray | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 13"
    },
    {
        "id": "33374601412798",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-14.jpg?v=1783398175",
        "alt": "color:Gray | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 14"
    },
    {
        "id": "33374601445566",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-15.jpg?v=1783398175",
        "alt": "color:Gray | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 15"
    },
    {
        "id": "33374601478334",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-16.jpg?v=1783398176",
        "alt": "color:Gray | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 16"
    },
    {
        "id": "33435719631038",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-pink-white-bg-main-20260713.jpg?v=1783958460",
        "alt": "color:Pink | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374601511102",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-17.jpg?v=1783398175",
        "alt": "color:Pink | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 17"
    },
    {
        "id": "33374601543870",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-18.jpg?v=1783398176",
        "alt": "color:Pink | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 18"
    },
    {
        "id": "33374601576638",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-19.jpg?v=1783398175",
        "alt": "color:Pink | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 19"
    },
    {
        "id": "33374601609406",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-20.jpg?v=1783398176",
        "alt": "color:Pink | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 20"
    },
    {
        "id": "33435720024254",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps4-plus-yellow-white-bg-main-20260713.jpg?v=1783958467",
        "alt": "color:Yellow | Seibertron SPS-4 Plus 3M Thinsulate motorcycle gloves white background main image"
    },
    {
        "id": "33374601642174",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-21.jpg?v=1783398175",
        "alt": "color:Yellow | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 21"
    },
    {
        "id": "33374601674942",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-22.jpg?v=1783398175",
        "alt": "color:Yellow | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 22"
    },
    {
        "id": "33374601707710",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-23.jpg?v=1783398175",
        "alt": "color:Yellow | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 23"
    },
    {
        "id": "33374601740478",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-24.jpg?v=1783398175",
        "alt": "color:Yellow | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 24"
    },
    {
        "id": "33374601773246",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps4-plus-winter-gallery-25.jpg?v=1783398175",
        "alt": "color:all | Seibertron SPS-4 Plus 3M Thinsulate winter leather motorcycle gloves image 25"
    }
];
  var groups = {
    "Black": [
        "33435717009598",
        "33374600986814",
        "33374601019582",
        "33374601052350",
        "33374601085118",
        "33374601773246"
    ],
    "White": [
        "33435717435582",
        "33374601117886",
        "33374601150654",
        "33374601183422",
        "33374601216190",
        "33374601773246"
    ],
    "Brown": [
        "33435717599422",
        "33374601248958",
        "33374601281726",
        "33374601314494",
        "33374601347262",
        "33374601773246"
    ],
    "Gray": [
        "33435718811838",
        "33374601380030",
        "33374601412798",
        "33374601445566",
        "33374601478334",
        "33374601773246"
    ],
    "Pink": [
        "33435719631038",
        "33374601511102",
        "33374601543870",
        "33374601576638",
        "33374601609406",
        "33374601773246"
    ],
    "Yellow": [
        "33435720024254",
        "33374601642174",
        "33374601674942",
        "33374601707710",
        "33374601740478",
        "33374601773246"
    ]
};
  var entryById = {};
  var colorAliases = {};
  entries.forEach(function (entry) { entryById[entry.id] = entry; });
  Object.keys(groups).forEach(function (color) {
    colorAliases[color.toLowerCase()] = color;
    if (color === 'Gray') colorAliases.grey = color;
    if (color === 'Yellow') colorAliases['fluorescent yellow'] = color;
  });

  function section() { return document.querySelector('.auto-product[data-product-handle="' + handle + '"]'); }
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf('sps4-plus-gallery-restore-20260713.js') !== -1; });
    if (own) return own.src.replace('sps4-plus-gallery-restore-20260713.js', file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function ensureStyle() {
    if (document.getElementById('sps4-plus-gallery-restore-style-20260713')) return;
    var style = document.createElement('style');
    style.id = 'sps4-plus-gallery-restore-style-20260713';
    style.textContent = '.auto-product[data-product-handle="' + handle + '"] [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image{display:block;width:100%;height:100%}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image img{display:block;width:100%;height:100%;object-fit:contain;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}';
    document.head.appendChild(style);
  }
  function normalizeColor(value) {
    var key = String(value || '').trim().toLowerCase();
    return colorAliases[key] || value || 'Black';
  }
  function selectedValue(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return normalizeColor(checked ? checked.value : 'Black');
  }
  function groupFor(value) {
    return (groups[normalizeColor(value)] || groups.Black || []).map(function (id) { return entryById[id]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryById[preferredId] && visibleIds[preferredId] ? entryById[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = normalizeColor(label.getAttribute('data-auto-visual-option-value') || '');
      var entry = groupFor(value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="78" height="78" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function replaceChart(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img.auto-product__guide-image, img[src*="sps-4-plus-combined-size-chart"], img[src*="sps-4-plus-size-chart-vertical"]'));
    imgs.forEach(function (img) {
      img.src = scriptUrl(chartFile);
      img.srcset = '';
      img.width = 971;
      img.height = 1619;
      img.alt = 'Seibertron SPS-4 Plus adult and youth motorcycle gloves size chart with hand measurement method';
    });
  }
  function run() {
    var root = section();
    if (!root) return;
    ensureStyle();
    replaceChart(root);
    hydrateSwatches(root);
    showGroup(root, selectedValue(root));
    if (!root.dataset.sps4PlusGalleryRestoreBound) {
      root.dataset.sps4PlusGalleryRestoreBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          [0, 350, 900, 1600].forEach(function (delay) {
            window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceChart(root); }, delay);
          });
        }
      });
    }
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [80, 250, 600, 1000, 1500, 2200, 3200, 5000, 7500, 10000].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
